import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import ConfiguracaoGatewayPagamentoModel from "@/models/configuracaoGatewayPagamentoModel";
import configuracaoGatewayPagamentoService from "@/services/configuracaoGatewayPagamentoService";

import ListComponentBase from "../../listComponentBase";

@Component
export default class ConfiguracaoGatewayPagamentoListComponent extends ListComponentBase<ConfiguracaoGatewayPagamentoModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("gatewayPagamentoDescricao", "Descrição", GridColumnType.String),
            new GridColumn("ativo", this.$t("__.ts.ativo"), GridColumnType.Boolean),
        ];
    }

    private beforeMount() {
        this.setPropsCached(configuracaoGatewayPagamentoService, "configuracaogatewaypagamento", "descricao");
    }
}
